(ns motorsaif.web.pages.request
  (:require
   [motorsaif.web.components :as c]
   [motorsaif.log :as log]
   [motorsaif.web.admin.contextual-info :as admin-contextual-info]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.web.photos :as photos]
   [promesa.core :as p]
   [motorsaif.string :as string :refer [format]]
   [motorsaif.time :as time]
   [reagent.core :as r]
   [motorsaif.url :as url]
   [motorsaif.utils :as utils]
   [re-frame.core :as rf :refer [subscribe]]))

;; DESIGN
;; For each problem, a grid that can take 3 images and display them like this would be great.
;; https://dribbble.com/shots/5747363-Augmented-Reality-and-Profile-iOS-Mobile-Design
;;
;;
;;

(def status-state->actions
  {:expired [:resolved :active :deleted]
   :active [:resolved :deleted]
   :resolved [:active :deleted]})

(defn- request-item-media [{:keys [media]}]
  (into [:div.photo-grid
         {:class (str "items-" (count media))}
         (map-indexed
          (fn [idx itm]
            (let [{media-id :db/id
                   path :media/path} itm
                  src (url/uploaded-media {:media itm
                                           :size :med})]
              ^{:key media-id}
              [:div.media-item
               {:on-click #(photos/photoswipe idx media)}
               [:img {:src src}]])) media)]))

(defn copy-to-clipboard [to-copy]
  (let [s (tr [:page.request.clipboard.title])
        *text (r/atom s)
        change-s (fn [new-s]
                   (when (= s @*text)
                     (reset! *text new-s)
                     (js/setTimeout (fn []
                                      (reset! *text s)) 3000)))]
    (fn []
      [:button.copy.btn
       {:on-click
        (fn []
          (p/let [ret
                  (-> (p/promise
                       (js/window.navigator.clipboard.writeText to-copy))
                      (p/catch (fn [e] :failed)))]
            (if (= ret :failed)
              (change-s (tr :page.request.clipboard.fail))
              (change-s (tr :page.request.clipboard.copied)))))}
       @*text])))

(defn normalize-phone-number [s]
  (let [s (last (re-find #"^(\+971|00971)?(\d+)" s))
        s (last (re-find #"(^0)?(\d{8,9})" s))]
    (str "+971" s)))

(defn owner-controls [request]
  (let [id (:db/id request)
        status (get-in request [:request/status :db/ident])
        *expanded (r/atom false)]
    (fn []
      [:div.owner-controls
       [:button.btn.primary-outline
        {:on-click #(swap! *expanded not)}
        "Request Actions "
        (if @*expanded
          [:i.fas.fa-caret-up]
          [:i.fas.fa-caret-down])]
       (when @*expanded
         [:div.wrap
          [:span.txt.current
           "Current status: "
           [:span.bold
            (tr [:domain :request :status :state status] (name status))]]
          (into [:div.actions "Change Request Status: "
                 (when @(subscribe [:is-admin?])
                   [c/confirm-action
                    (tr [:domain :request :status :action :expired] "Expire")
                    #(rf/dispatch [:update-request-status id :expired])
                    2000])]

                (map (fn [k]
                       [c/confirm-action
                        (tr [:domain :request :status :action k] (name k))
                        #(rf/dispatch [:update-request-status id k])
                        (if (= k :deleted)
                          1000
                          600)])
                     (get status-state->actions status)))
          [:a.btn.primary.full
           {:href (routes/path-for :edit-request {:id id})} "Edit Request"]])])))

(defn request-object [{:keys [request is-owner?]}]
  (let [{owner :owner
         created :date-time/created
         short-id :short/id
         request-id :db/id
         :keys [messages]
         :request/keys [whatsapp description media category type]} request
        ;; {category :tag/title} category
        {owner-id :db/id
         :user/keys [handle]} owner
        current-owner-id @(subscribe [:current-owner-id])
        {request-id :db/id
         created :date-time/created
         {:user/keys [handle]} :owner
         :request/keys [object media description category]} request
        {:car/keys [year make model vin]} object
        biz? (:business/name owner)
        handle (utils/owner-handle owner)
        part-condition (get-in request [:part/condition :db/ident])
        category (:tag/title category)
        car (format "%s %s %s" year make model)
        request-type (:db/ident type)

        loc-name (or
                  (-> request :request/geo-location)
                  (-> request :request/location :location/name))]
    [:div.box
     [:div.post-profile
      [c/avatar-letter-with-handle {:owner owner
                                    :letter-class "square"
                                    :posted created}]]
     ;; [:div.category category]
     [request-item-media {:media media}]

     [:section
      (-> [:div.grid.summary
           [:div.row
            [:span.title (tr :page.request.request-id)] [:span.val.uc short-id]]
           [:div.row
            [:span.title
             (tr :page.request.request-type)]
            [:span.val
             (tr [:domain :request-type request-type])]]
           [:div.row
            [:span.title (tr :page.request.category)] [:span.val category]]]
          (cond-> part-condition
            (conj
             [:span.title (tr :page.request.condition)]
             [:span.val
              (tr [:domain :part-condition part-condition])]))
          (conj
           [:span.title (tr :page.request.vehicle)] [:span.val car]))]

     (when vin
       [:div.vin-wrap
        [:span.title "VIN"]
        [:div.vin.text vin]
        [copy-to-clipboard vin]])

     [:section
      [:div.description.clr-neutral.bold (tr :page.request.description)]
      [:p.desc description]]

     (when @(rf/subscribe [:is-business?])
       [:section
        [:div.description.clr-neutral.bold "Location"]
        [:p.desc loc-name]])

     [:div.float
      (when (.-share js/navigator)
        [:button.btn.share
         {:type "button"
          :on-click (fn []
                      (.then (.share js/navigator #js {:title (tr :page.request.share-action.title)
                                                       :text (tr :page.request.share-action.text)
                                                       :url (.-location.href js/window)})
                             (fn [e] nil)))}
         [:div
          (tr :page.request.share)
          [:i.fas.fa-share]]])
      (when @(rf/subscribe [:is-business?])
        [:a.msg
         {:href
          (routes/path-for :ops-chat {:request-id request-id
                                      :owner-id current-owner-id})}
         [:div
          (tr :page.request.message)
          [:i.fas.fa-paper-plane]]])]]))

;; To create your own link with a pre-filled message that will automatically appear in the text field of a chat, use https://wa.me/whatsappphonenumber/?text=urlencodedtext where whatsappphonenumber is a full phone number in international format and URL-encodedtext is the URL-encoded pre-filled message.3 Oct 2018


(defn root []
  (let [{:keys [id]} @(subscribe [:route/parameters])
        *loaded? (subscribe [:all-ajax-loaded? :bootstrap-data])
        *request (subscribe [:request id])
        ?role-id @(subscribe [:current-role-id])]
    (when @*loaded?
      (if @*request
        (do
          (when ?role-id
            (rf/dispatch [:touch-topic id {:role ?role-id}]))
          (let [{{request-type :db/ident} :request/type
                 short-id :short/id
                 {owner-id :db/id} :owner} @*request
                loc-name (or
                          (-> @*request :request/geo-location)
                          (-> @*request :request/location :location/name))
                is-owner? (= @(subscribe [:current-owner-id]) owner-id)
                request-type (tr [:domain :request-type request-type])]

            [:<>
             [c/header-with-back
              (tr [:page.request.header] [request-type])
              {:subtitle (string/upper-case short-id)
               :fallback-back-route :feed}]
             [:div#content.container-sm
              (when @(subscribe [:admin-overlay])
                [admin-contextual-info/request-page @*request])
              #_(when
                    (or
                     @(subscribe [:is-admin?])
                     is-owner?)
                  [:a {:href (routes/path-for :edit-request {:id id})} "Edit"])
              ;; [main-info @*request]

              (when (or is-owner?
                        @(subscribe [:admin-overlay]))
                [owner-controls @*request])             
              [request-object {:request @*request
                               :is-owner? is-owner?}]]]))
        [:div.not-found
         [:h1 (tr :page.request.not-found/heading)]
         [:h2 (tr :page.request.not-found/helper)]]))))
